import React from 'react';
import { useNavigate } from 'react-router-dom';

const CompanyCard = ({ company }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/book-meeting/${company.id}`);
  };

  // Logo URL'ini düzelt
  const getLogoUrl = (logo) => {
    if (!logo) return null;
    if (logo.startsWith('http')) return logo;
    const baseUrl = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
      ? 'http://localhost:8000'
      : 'https://api.uzak.co';
    return `${baseUrl}/logos/${logo}`;
  };

  // Parse description JSON
  const getDescriptions = (description) => {
    if (!description) return { desc1: '', desc2: '', desc3: '' };
    try {
      const descObj = typeof description === 'string' ? JSON.parse(description) : description;
      return {
        desc1: descObj.description_1 || descObj.field1 || '',
        desc2: descObj.description_2 || descObj.field2 || '',
        desc3: descObj.description_3 || descObj.field3 || ''
      };
    } catch (e) {
      return { desc1: description, desc2: '', desc3: '' };
    }
  };

  const descriptions = getDescriptions(company.description);

  return (
    <div
      style={{
        backgroundColor: 'white',
        borderRadius: '20px',
        padding: '25px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        border: '2px solid #EDB404',
        boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
        position: 'relative',
        overflow: 'hidden'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-5px)';
        e.currentTarget.style.boxShadow = '0 15px 35px rgba(237, 180, 4, 0.2)';
        e.currentTarget.style.borderColor = '#d4a017';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.1)';
        e.currentTarget.style.borderColor = '#EDB404';
      }}
      onClick={handleClick}
    >
      {/* Top accent line */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        backgroundColor: '#EDB404',
        borderRadius: '20px 20px 0 0'
      }} />
      
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
        {/* Logo Section */}
        {company.logo && (
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: '#f8f9fa',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '3px solid #EDB404',
            overflow: 'hidden'
          }}>
            <img
              src={getLogoUrl(company.logo)}
              alt={`${company.name} logo`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                padding: '10px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
        )}
        
        {/* Company Name */}
        <div style={{ textAlign: 'center', width: '100%' }}>
          <h3 style={{ 
            fontSize: '1.5rem',
            fontWeight: '700',
            color: '#2c3e50',
            margin: '0 0 15px 0',
            lineHeight: '1.3'
          }}>
            {company.name}
          </h3>
          
          {/* Descriptions */}
          {(descriptions.desc1 || descriptions.desc2 || descriptions.desc3) && (
            <div style={{ 
              marginBottom: '15px',
              textAlign: 'left',
              padding: '0 10px',
              marginTop: '10px'
            }}>
              {descriptions.desc1 && (
                <p style={{ 
                  margin: '8px 0', 
                  color: '#555', 
                  fontSize: 'clamp(0.9rem, 2.3vw, 1rem)',
                  lineHeight: '1.6'
                }}>
                  {descriptions.desc1}
                </p>
              )}
              {descriptions.desc2 && (
                <p style={{ 
                  margin: '8px 0', 
                  color: '#555', 
                  fontSize: 'clamp(0.9rem, 2.3vw, 1rem)',
                  lineHeight: '1.6'
                }}>
                  {descriptions.desc2}
                </p>
              )}
              {descriptions.desc3 && (
                <p style={{ 
                  margin: '8px 0', 
                  color: '#555', 
                  fontSize: 'clamp(0.9rem, 2.3vw, 1rem)',
                  lineHeight: '1.6'
                }}>
                  {descriptions.desc3}
                </p>
              )}
            </div>
          )}
        </div>
        
        {/* Book Meeting Button */}
        <button
          style={{
            backgroundColor: '#EDB404',
            color: 'white',
            border: 'none',
            padding: '12px 30px',
            borderRadius: '25px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(237, 180, 4, 0.3)',
            minWidth: '180px'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#d4a017';
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(237, 180, 4, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#EDB404';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(237, 180, 4, 0.3)';
          }}
          onClick={handleClick}
        >
          Book a Meeting
        </button>
      </div>
    </div>
  );
};

export default CompanyCard;
